import BugTracker from './BugTrackerMongoDB';
import './index.css';

function App() {
  return <BugTracker />;
}

export default App;
